import { teacherServiceURL } from '../endpoint';

export const studentScoreURL = ({
  questionScoreId,
  studentId,
  isRostered,
}: {
  questionScoreId: number;
  studentId: number;
  isRostered: boolean;
}) => {
  const url = new URL(
    `/question_scores/${questionScoreId}/student/${studentId}`,
    teacherServiceURL
  );
  url.searchParams.append('isRostered', `${isRostered}`);
  return url;
};
